<template>
  <div class="container">
    <!-- banner轮播 -->
    <div class="swipperContainer">
      <swiper :options="swiperOption">
        <swiper-slide v-for="(slide, index) in swiperSlides" :key="index">
          <!-- <div class="swipperItem"></div> -->
          <img src="~@/assets/img/banner.png" alt="">
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <!-- 优质藏品，随心购 -->
    <div class="sectionItem">
      <div class="sectionTitle">
        <div class="titleText">优质藏品，随心购</div>
        <div class="titleLine"></div>
      </div>
      <div class="sectionCon minBox">
        <div class="hoverLine1">
          <hover-item1 :hoverIndex="1" />
          <hover-item1 :hoverIndex="2" />
          <hover-item1 :hoverIndex="3" />
        </div>
        <div class="hoverLine2">
          <hover-item1 :hoverIndex="4" />
          <hover-item1 :hoverIndex="5" />
        </div>
        <div class="hoverLine3">
          <hover-item1 :hoverIndex="6" />
          <hover-item1 :hoverIndex="7" />
          <hover-item1 :hoverIndex="8" />
        </div>
      </div>
    </div>
    <!-- 极速入驻，轻松赚 -->
    <div class="sectionItem">
      <div class="sectionTitle">
        <div class="titleText">极速入驻，轻松赚</div>
        <div class="titleLine"></div>
      </div>
      <div class="sectionCon minBox">
        <div class="hoverLine4">
          <hover-item2 :hoverIndex="1" />
          <hover-item2 :hoverIndex="2" />
          <hover-item2 :hoverIndex="3" />
          <hover-item2 :hoverIndex="4" />
        </div>
        <div class="top-img"  @click="handleTop">
          <img src="../../assets/img/top.png" />
        </div>
      </div>
    </div>
    <!-- 业务领域，更专注 -->
    <div class="sectionItem">
      <div class="sectionTitle">
        <div class="titleText">业务领域，更专注</div>
        <div class="titleLine"></div>
      </div>
      <div class="sectionCon minBox">
        <div
          class="describText"
        >按照国际现代艺术品的一级市场标准，创新理念，开放合作，并积极协同政府一起打造国内一流的艺术品一级市场。借助互联网、移动终端技术发展线上交易，实现线上与线下的良性互动。深度与文化文物单位馆藏文化资源，博物馆、美术馆、图书馆等单位开展合作，拓展文化创意产品开发投资、设计制作和营销渠道，开发出具有艺术性和实用性、适应现代生活需求的艺术衍生品。</div>
        <div class="hoverLine5">
          <hover-item3 :hoverIndex="1" />
          <hover-item3 :hoverIndex="3" />
          <hover-item3 :hoverIndex="5" />
        </div>
        <div class="hoverLine6">
          <hover-item3 :hoverIndex="2" />
          <hover-item3 :hoverIndex="4" />
        </div>
      </div>
      <div class="hoverLine7">
        <hover-item4 :hoverIndex="1" />
        <hover-item4 :hoverIndex="2" />
        <hover-item4 :hoverIndex="3" />
      </div>
    </div>
    <div class="applyBox">
      <div class="applyTop minBox">
        <div class="applyItem applyItem1" @click="toLogin()">
          <div class="icon">
            <img src="~@/assets/img/home/applyShop.png" alt />
          </div>
          <div class="content">
            <div class="title">商家申请</div>
            <div class="text">立即入驻，开启年入百万掘金之路</div>
          </div>
        </div>
        <div class="applyItem" @click="toLogin()">
          <div class="icon">
            <img src="~@/assets/img/home/applyJianding.png" alt />
          </div>
          <div class="content">
            <div class="title">鉴定师申请</div>
            <div class="text">立即入驻，与行业大师共鉴藏品</div>
          </div>
        </div>
      </div>
      <div class="applyBot" @click="toLogin()">立即注册</div>
    </div>
  </div>
</template>
<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { fetchPhotoWall  } from '@/api/index'
import HoverItem1 from "./components/hoverItem1";
import HoverItem2 from "./components/hoverItem2";
import HoverItem3 from "./components/hoverItem3";
import HoverItem4 from "./components/hoverItem4";
export default {
  name: "Home",
  components: {
    swiper,
    swiperSlide,
    HoverItem1,
    HoverItem2,
    HoverItem3,
    HoverItem4
  },
  data() {
    return {
      swiperOption: {
        loop: true,
        autoplay: true,
        delay: 3000,
        speed: 1000,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        }
      },
      swiperSlides: [1]
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    goAdminPage(num) {
      switch (num) {
        case 1:
          alert("商家申请");
          break;
        case 2:
          alert("鉴定师申请");
          break;
        case 3:
          alert("注册");
          break;
      }
    },
    toLogin(){
      window.location.href ='https://www.51ysscw.com/system/#/login';
    },
    getList () {
      fetchPhotoWall().then(res => {
        if (res.data.code === 0) {
          this.swiperSlides=res.data.data.content
        }
      })
    },
    handleTop() {
     window.scrollTo(0, 0);
    }
  }
};
</script>
<style lang="scss">
.swiper-pagination-bullet {
  width: 40px !important;
  height: 6px !important;
  background: #fff !important;
  opacity: 0.3 !important;
  border-radius: 3px !important;
  cursor: pointer !important;
  transition: all 0.5s !important;
}
.swiper-pagination-bullet:hover {
  opacity: 0.8!important;
}
.swiper-pagination-bullet-active {
  background: rgba(160, 0, 0, 1) !important;
  opacity: 0.8 !important;
}
</style>
<style lang="scss" scoped>
.container {
  width: 100%;
  .swipperContainer {
    height: 580px;
    width: 100%;
    min-width: 1200px;
    .swiper-container {
      width: 100%;
      height: 100%;
      img {
        width: 100%;
        object-fit: cover;
        // height:auto!important;
      }
    }
  }
  .sectionItem {
    position: relative;
    .top-img {
        position: absolute;
        width: 40px;
        height: 40px;
        right: -70px;
        top: 54px;
      }
    .sectionTitle {
      overflow: hidden;
      .titleText {
        text-align: center;
        font-size: 36px;
        color: #1a1a1a;
        margin-top: 60px;
      }
      .titleLine {
        width: 120px;
        height: 2px;
        background: rgba(160, 0, 0, 1);
        border-radius: 1px;
        margin: 20px auto 0;
      }
    }
    .sectionCon {
      margin-top: 40px;
      // 1
      .hoverLine1,
      .hoverLine3 {
        display: flex;
        justify-content: space-between;
      }
      .hoverLine2 {
        padding: 0 120px;
        display: flex;
        justify-content: space-around;
      }
      .hoverLine2,
      .hoverLine3 {
        margin-top: -60px;
      }
      // 2
      .hoverLine4 {
        display: flex;
        justify-content: space-between;
      }
      // 3
      .describText {
        margin: 0 auto;
        width: 1190px;
        font-size: 14px;
        color: #666;
        line-height: 21px;
      }
      .hoverLine5 {
        margin-top: 80px;
        padding: 0 34px;
        display: flex;
        justify-content: space-between;
      }
      .hoverLine6 {
        margin-top: -115px;
        padding: 0 250px;
        display: flex;
        justify-content: space-between;
      }
    }
    .hoverLine7 {
      width: 100%;
      margin-top: 40px;
      display: flex;
      justify-content: center;
      background: #000;
    }
  }
  .applyBox {
    padding: 60px 0 52px;
    background:rgba(242,237,237,1);
    .applyTop {
      display: flex;
      .applyItem1 {
        border-right: 1px solid #cccccc;
      }
      .applyItem {
        width: 50%;
        display: flex;
        justify-content: center;
        cursor: pointer;
        .icon {
          width: 60px;
          height: 60px;
          margin-right: 30px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .content {
          .title {
            font-size: 20px;
            color: #333;
          }
          .text {
            font-size: 16px;
            color: #666;
            margin-top: 12px;
          }
        }
      }
    }
    .applyBot {
      margin: 48px auto 0;
      width: 180px;
      height: 60px;
      line-height: 60px;
      text-align: center;
      color: #fff;
      background: rgba(204, 0, 0, 1);
      border-radius: 30px;
      font-size: 20px;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/home/home.vue